import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { createSquareIntegrationAndStartOAuth } from '../../helpers';
import { addToast } from '../actions';
import {
    squareConnectorsApiResponseError,
    squareConnectorsApiResponseSuccess,
} from './actions';
import { SquareConnectorsActionTypes } from './constants';

export function* createSquareIntegrationAndStartOAuthSaga({ payload: { squareIntegration } }) {
    try {
        const response = yield call(createSquareIntegrationAndStartOAuth, squareIntegration);
        yield put(squareConnectorsApiResponseSuccess(
            SquareConnectorsActionTypes.CREATE_INTEGRATION_AND_START_OAUTH_REQUEST,
        ));
        if (response.redirected) window.location.href = response.url;
    } catch (error) {
        const message = error?.errors?.[0]?.message || error?.message || 'Failed to start Square connection';
        yield put(addToast({ desc: message, type: 'error' }));
        yield put(squareConnectorsApiResponseError(
            SquareConnectorsActionTypes.CREATE_INTEGRATION_AND_START_OAUTH_REQUEST,
            error,
        ));
    }
}

function* watchSquareOAuth() {
    yield takeLatest(
        SquareConnectorsActionTypes.CREATE_INTEGRATION_AND_START_OAUTH_REQUEST,
        createSquareIntegrationAndStartOAuthSaga,
    );
}

export default function* squareConnectorsSaga() {
    yield all([fork(watchSquareOAuth)]);
}
